export default "__VITE_ASSET__zKu$dhb4__"